export const fontFamily = '"Nunito Sans", sans-serif';
